var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("button"),_c('div',{class:[_vm.down ? 'p-down' : '', _vm.right ? 'p-right' : '', `list_pop_up ${_vm.dropsize}`]},[_vm._t("dropcontent")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }